var map = {
	"./ico-bz.png": 940,
	"./ico-fb.png": 941,
	"./ico-gp.png": 942,
	"./ico-insta.png": 943,
	"./ico-pi.png": 944,
	"./ico-snapchat.png": 945,
	"./ico-t.png": 946,
	"./ico-tw.png": 947,
	"./ico-yt.png": 948
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 939;


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/social_icons ^\.\/.*$
// module id = 939
// module chunks = 4